import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";
import WebServiceContext from "../../webService/WebServiceContext";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, scales, } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { Loading } from "../SVG";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    scales
);


const money = (value: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
    });
    return formatter.format(value)
}


type PerformanceChatProps = {
    currentYear:number
}

const PerformanceChat = (props:PerformanceChatProps) => {
    const ws = useContext(WebServiceContext)

    const [value, setValue] = useState<number>(0)
    const [resValue, setResValue] = useState<number>(0)
    const [percent, setPercent] = useState<string>("")
    const [response, setResponse] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(true)


    useEffect(() => {
        setIsLoading(true)
        ws.webservice.asyncPerformance("44004_績效業績", props.currentYear).then((res: any) => {
            
            setIsLoading(false)
            let perValue:number = res[0]['年終績效']?parseInt(res[0]['年終績效']):0
            setValue(perValue)

            if (perValue < 300000) {
                setResValue(300000)
                setPercent("2%")
                //_percent = "0%"; 
                //myChart_Performance.config.data.datasets[0].label = "0%";
                //myChart_Performance.options.scales.xAxes[0].ticks.max = 300000;
                //$("#endGoal").html('再<span class="highlight">' + formatMoney(300000 - perValue) + '</span>到達<span class="highlight">2%</span>!');
            } else if (perValue < 500000) {
                setResValue(500000)
                setPercent("4%")
                //_percent = "2%"; 
                //myChart_Performance.config.data.datasets[0].label = "2%";
                //myChart_Performance.options.scales.xAxes[0].ticks.max = 500000;
                //_myP = perValue * 0.02;
                //$("#endGoal").html('再<span class="highlight">' + formatMoney(500000 - perValue) + '</span>到達<span class="highlight">4%</span>!');
            } else if (perValue < 1000000) {
                setResValue(1000000)
                setPercent("8%")
                //_percent = "4%";
                //myChart_Performance.config.data.datasets[0].label = "4%";
                //myChart_Performance.options.scales.xAxes[0].ticks.max = 1000000;
                //_myP = perValue * 0.04;
                //$("#endGoal").html('再<span class="highlight">' + formatMoney(1000000 - perValue) + '</span>到達<span class="highlight">8%</span>!');
            } else if (perValue < 2000000) {
                setResValue(2000000)
                setPercent("12%")
                //_percent = "8%";
                //myChart_Performance.config.data.datasets[0].label = "8%";
                //myChart_Performance.options.scales.xAxes[0].ticks.max = 2000000;
                //_myP = perValue * 0.08;
                ///$("#endGoal").html('再<span class="highlight">' + formatMoney(2000000 - perValue) + '</span>到達<span class="highlight">12%</span>!');
            } else if (perValue < 3000000) {
                setResValue(3000000)
                setPercent("16%")
                //_percent = "12%";
                //myChart_Performance.config.data.datasets[0].label = "12%";
                //myChart_Performance.options.scales.xAxes[0].ticks.max = 3000000;
                //_myP = perValue * 0.12;
                //$("#endGoal").html('再<span class="highlight">' + formatMoney(3000000 - perValue) + '</span>到達<span class="highlight">16%</span>!');
            } else if (perValue > 3000000) {
                setResValue(4000000)
                setPercent("20%")
                //_percent = "16%"; 
                //myChart_Performance.config.data.datasets[0].label = "16%";
                //myChart_Performance.options.scales.xAxes[0].ticks.max = 4000000;
                //_myP = perValue * 0.16;
                //$("#endGoal").html('再<span class="highlight">' + formatMoney(4000000 - perValue) + '</span>到達<span class="highlight">20%</span>!');
            } else if (perValue > 4000000) {
                setResValue(4000000)
                setPercent("20%")
                //_percent = "20%";
                //myChart_Performance.config.data.datasets[0].label = "20%";
                //myChart_Performance.options.scales.xAxes[0].ticks.max = perValue + 5000000;
                //_myP = perValue * 0.2;
                //$("#endGoal").html("到達20%!您真厲害!");
            }
        })
        return
    }, [props.currentYear])

    if (isLoading) {
        return (<Loading/>)
    } else {
        return (
            <>
            <div className="card-short">
                <span className="value">
                    {money(value)}
                </span>
            </div>
            <div className="BarChatBox card-content">
                <div className="endGoal">
                    再
                    <span>{money(resValue - value)}</span>
                    到達
                    <span className="highlight">{percent}</span>!
                </div>
                <Bar
                    height={60}
                    data={{
                        labels: [""],
                        datasets: [
                            {
                                data: [value],
                                backgroundColor: 'rgba(180, 220, 100, 0.6)',
                                borderColor: 'rgba(180, 220, 100, 1)',
                            },
                        ]
                    }}
                    options={{
                        indexAxis: 'y' as const,
                        scales: {
                            x: {
                                min: 0,
                                max: resValue,
                                ticks: {
                                    callback: (value):string => {
                                        const _v:number = value as number;
                                        return `${ (_v/ 10000).toString()}萬`
                                    }
                                }
                            },
                        },
                        elements: {
                            bar: {
                                borderWidth: 2,
                            },
                        },
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: { 
                                enabled: false
                            }
                        }
                    }}
                />
              
            </div>
            </>
        )
    }
};

export default PerformanceChat